import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { withPrefix } from "gatsby";
export const CoverImage = () => <img src={withPrefix('/images/3dassets_mountains.png')} alt="3D Mountains" />;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  CoverImage,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Developing an Extended Reality application will require the usage of 3D assets such as 3D models.`}</p>
    </PageDescription>


    <CoverImage mdxType="CoverImage" />
    <p>{`To accelerate the creation of your prototype, please feel free to use existing content in 3D asset stores such as`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assetstore.unity.com/3d"
        }}>{`3D Animations & Models | Unity Asset Store`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.unrealengine.com/marketplace/en-US/store"
        }}>{`Unreal Engine Marketplace | Store of UE Assets for Games and 3D Rendering - UE Marketplace`}</a></li>
    </ul>
    <h2>{`Assets from Swiss Re`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://drive.google.com/drive/folders/1YoWkNRFjnNcfIHk71voG9-kO44reWToZ?usp=sharing"
        }}>{`https://drive.google.com/drive/folders/1YoWkNRFjnNcfIHk71voG9-kO44reWToZ?usp=sharing`}</a></li>
      <li parentName="ul">{`PW: SwissReSwiss`}</li>
    </ul>
    <p>{`If the desired 3D asset entails costs, please reach out to us on Discord.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      